import { Theme } from '@mui/material/styles'
export const styles = {
  arrow: {
    marginBottom: (theme: Theme) => theme.spacing(0.4),
    marginLeft: (theme: Theme) => theme.spacing(0.6),
    verticalAlign: 'middle',
  },

  link: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#1565C0',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}
